module.exports = __webpack_public_path__ + "static/media/google_review.b839eadc.png";